export default __webpack_public_path__ + "static/media/signet.8d69cd52.png";